const buildFormData = (formData: FormData, entity: any, parentKey?: any) => {
  if (
    entity &&
    typeof entity === "object" &&
    !(entity instanceof Date) &&
    !(entity instanceof File)
  ) {
    Object.keys(entity).forEach((key) => {
      buildFormData(
        formData,
        entity[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    // const value = entity === null ? null : entity;
    if (entity !== null && entity !== "") {
      formData.append(parentKey, entity);
    }
  }
};

export const jsonToFormData = (entity: any) => {
  const formData = new FormData();

  buildFormData(formData, entity);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  // if (formData?.entries()) {
  //   for (const key of formData.entries()) {
  //     console.log(key[0] + ", " + key[1]);
  //   }
  // }

  return { formData, config };
};